<div style="margin-top: 1px;">
  <p-table class="events-table" [value]="entries" [lazy]="true" [totalRecords]="totalCount" [resizableColumns]="true"
    [(rows)]="rows" [paginator]="true" [sortOrder]="-1" (onLazyLoad)="loadData($event)"
    [pageLinks]="3" [rowsPerPageOptions]="[10,20,30,40,50,60,70,80,90,100]"
    [scrollable]="true" scrollHeight="calc(75vh - 0px)" dataKey="dataKey"
    (sortFunction)="doCustomSort($event)" [customSort]="true" [rowHover]="true"
    [(first)]="skip">

    <ng-template pTemplate="header">
      <tr>
        @for (col of cols; track col) {
          <th [ngStyle]="col.style" pResizableColumn [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
      </tr>
      <tr class="uv-table-filter">
        @for (col of cols; track col) {
          <th>
            @if (col.field !== 'created') {
              <input pInputText type="text" style="width: 100%;"
                (input)="filterUpdated(col.field, $event.target.value, col.filterMatchMode);">
            }
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
      <tr>
        @for (col of cols; track col) {
          <td [ngStyle]="col.style" pTooltip="{{col.createTooltip ? rowData[col.field] : ''}}">
            <span class="uv-table-value">{{ rowData[col.field] }}</span>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>

  <div style="text-align: center; margin-top: 5px;">
    <button type="button" pButton icon="fa fa-refresh" (click)="updateEvents()" [disabled]="false"
    label="Refresh" title="Refresh events"></button>
  </div>
</div>
